import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import MoreMenuContent from './MoreMenuContent';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
import MoreMenuMobileDropdown from './MoreMenuMobileDropdown';
import DesktopShareModal from '../../../SharePopup/DesktopSharePopup/DesktopShareModal';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import s from './MoreButton.scss';
export var MoreButton = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useState(false), sharePopupVisible = _b[0], setSharePopupVisible = _b[1];
    if (isMobile) {
        return (React.createElement(BiButton, { className: s['mobile-button'] },
            React.createElement(ActionBarIcon, { icon: EllipsisIcon }),
            React.createElement(MoreMenuMobileDropdown, { deviation: deviation })));
    }
    return (React.createElement(React.Fragment, null,
        sharePopupVisible && (React.createElement(DesktopShareModal, { onRequestClose: function () { return setSharePopupVisible(false); }, deviation: deviation })),
        React.createElement(ActionBarItemWrapper, { allowMobilePopover: true, placement: isMobile ? 'top-end' : undefined, renderPopover: function (_a) {
                var closeTooltip = _a.closeTooltip;
                return (React.createElement(MoreMenuContent, { deviation: deviation, closeTooltip: closeTooltip, showDesktopDeviationSharePopup: function () { return setSharePopupVisible(true); } }));
            }, tooltip: t('actionbar.more.tooltip'), openBiData: {
                evid: BiEventType.MORE_MENU_CLICK,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                sectionname: 'deviation',
            } },
            React.createElement(ActionBarToggleButton, { icon: EllipsisIcon }))));
};
MoreButton.displayName = 'MoreButton';
export default MoreButton;
//# sourceMappingURL=MoreButton.js.map